import React from 'react'
import {
  BooleanField,
  BooleanInput,
  Create,
  Datagrid,
  Edit,
  EditButton,
  List,
  Show,
  ShowButton,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput,
  useRecordContext
} from 'react-admin'

const ApiUrlField = () => {
  const record = useRecordContext()
  if (!record) {
    return null
  }

  const url = `https://api.blocksdecoded.com/v1/status/app-state?version=${encodeURIComponent(record.version)}`

  return <a href={url} target="_blank" rel="noopener noreferrer">{url}</a>
}

const filters = [
  <TextInput source="version" label="Version" alwaysOn />,
]

const AppStateList = props => (
  <List {...props} filters={filters}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="version" />
      <BooleanField source="swap_enabled" />
      <EditButton />
      <ShowButton />
    </Datagrid>
  </List>
)

const AppStateEdit = props => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput disabled source="id" />
      <TextInput source="version" />
      <BooleanInput source="swap_enabled" />
    </SimpleForm>
  </Edit>
)

const AppStateCreate = props => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="version" />
      <BooleanInput source="swap_enabled" defaultValue={true} />
    </SimpleForm>
  </Create>
)

const AppStateShow = props => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="version" />
      <BooleanField source="swap_enabled" />
      <ApiUrlField label="Api url" />
    </SimpleShowLayout>
  </Show>
)

export { AppStateList, AppStateEdit, AppStateCreate, AppStateShow }
